import { render, staticRenderFns } from "./TransferDrawer.vue?vue&type=template&id=a3239122"
import script from "./TransferDrawer.vue?vue&type=script&lang=js"
export * from "./TransferDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports